import { render, staticRenderFns } from "./FouroverDesignPrices.vue?vue&type=template&id=41a8a119&scoped=true"
import script from "./FouroverDesignPrices.vue?vue&type=script&lang=js"
export * from "./FouroverDesignPrices.vue?vue&type=script&lang=js"
import style0 from "./FouroverDesignPrices.vue?vue&type=style&index=0&id=41a8a119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8a119",
  null
  
)

export default component.exports